import { Divider, Space } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import React from 'react';
import { SubSubtitle, SubSubtitleStart } from '.';

const LogoYTexto = ({ logo, texto, width = 150 }) => {
  const screens = useBreakpoint();
  return (
    <>
      {screens && screens.md === true && (
        <Space split={<Divider type="vertical" style={{ height: '3.5em' }} />}>
          <div
            style={{
              width,
              minWidth: width,
              maxWidth: width,
              maxHeight: width,
              minHeight: width,
              position: 'relative'
            }}
          >
            <img
              src={logo}
              alt="logo"
              style={{
                maxWidth: '100%',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
              }}
            />
          </div>
          <SubSubtitleStart>{texto}</SubSubtitleStart>
        </Space>
      )}
      {screens && screens.md === false && (
        <div
          style={{
            textAlign: 'center'
          }}
        >
          <img src={logo} alt="logo" style={{ width }} />
          <SubSubtitle>{texto}</SubSubtitle>
        </div>
      )}
    </>
  );
};

export default LogoYTexto;
